import {normalize} from 'normalizr';
import {getEndpoint, getHeaders, getMPPEndpoint} from '../../helpers/endpoint';
import {
  leagueActiveMPPSchema,
  leagueMPPSchema,
  leagueSchema,
} from '../../schemas/league';
import {receiveEntities} from '../entities';

export const REQUEST_FETCH_LEAGUE = 'REQUEST_FETCH_LEAGUE';
export const SUCCESS_FETCH_LEAGUE = 'SUCCESS_FETCH_LEAGUE';
export const FAIL_FETCH_LEAGUE = 'FAIL_FETCH_LEAGUE';

export const fetchLeague = (leagueId, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_LEAGUE, leagueId, scope});

    fetch(getEndpoint('fetchLeague', leagueId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_LEAGUE,
            error: data.error,
            leagueId,
            scope,
          });
        else dispatch(successFetchLeague(data, leagueId, scope));
      })
      .catch((error, type = FAIL_FETCH_LEAGUE) => {
        dispatch({type, error, leagueId, scope});
      });
  };
};

function successFetchLeague(response, leagueId, scope) {
  return dispatch => {
    const normalized = normalize(response.league, leagueSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_LEAGUE,
      receivedAt: Date.now(),
      id: normalized.result,
      leagueId,
      scope,
    });
  };
}

export const REQUEST_FETCH_MPP_LEAGUE = 'REQUEST_FETCH_MPP_LEAGUE';
export const SUCCESS_FETCH_MPP_LEAGUE = 'SUCCESS_FETCH_MPP_LEAGUE';
export const FAIL_FETCH_MPP_LEAGUE = 'FAIL_FETCH_MPP_LEAGUE';

export const fetchMPPLeague = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MPP_LEAGUE, payload, scope});

    fetch(getMPPEndpoint('fetchMPPLeague', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_MPP_LEAGUE,
            error: data.error,
            payload,
            scope,
          });
        else {
          data.id = payload.contestId;
          dispatch(successFetchMPPLeague(data, payload, scope));
        }
      })
      .catch((error, type = FAIL_FETCH_MPP_LEAGUE) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchMPPLeague(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, leagueMPPSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_MPP_LEAGUE,
      receivedAt: Date.now(),
      id: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_MPP_ACTIVE_LEAGUES =
  'REQUEST_FETCH_MPP_ACTIVE_LEAGUES';
export const SUCCESS_FETCH_MPP_ACTIVE_LEAGUES =
  'SUCCESS_FETCH_MPP_ACTIVE_LEAGUES';
export const FAIL_FETCH_MPP_ACTIVE_LEAGUES = 'FAIL_FETCH_MPP_ACTIVE_LEAGUES';

export const fetchMPPActiveLeagues = scope => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MPP_ACTIVE_LEAGUES, scope});

    fetch(getMPPEndpoint('fetchMPPActiveLeagues'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_MPP_ACTIVE_LEAGUES,
            error: data.error,
            scope,
          });
        else {
          data.sizeIntervals.id = 'leaguesStatsMPP';
          dispatch(successFetchMPPActiveLeagues(data, scope));
        }
      })
      .catch((error, type = FAIL_FETCH_MPP_ACTIVE_LEAGUES) => {
        dispatch({type, error, scope});
      });
  };
};

function successFetchMPPActiveLeagues(response, scope) {
  return dispatch => {
    const normalized = normalize(response.sizeIntervals, leagueActiveMPPSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_MPP_ACTIVE_LEAGUES,
      receivedAt: Date.now(),
      id: normalized.result,
      success: response.success,
      scope,
    });
  };
}

export const fetchLeaguePurchases = (payload, scope, onSuccess, onError) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('fetchLeaguePurchases', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
        } else {
          if (onSuccess) onSuccess(data);
        }
      })
      .catch(error => {
        if (onError) onError(error);
      });
  };
};

export const restartLeagueDraft = (payload, scope, onSuccess, onError) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('restartDraft', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
        } else {
          if (onSuccess) onSuccess(data);
        }
      })
      .catch(error => {
        if (onError) onError(error);
      });
  };
};

export const updateLeague = (payload, leagueId, onSuccess, onError) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('updateLeague', leagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
        } else {
          if (onSuccess) onSuccess(data, payload);
        }
      })
      .catch(error => {
        if (onError) onError(error);
      });
  };
};

export const updateMPPLeague = (payload, challengeId, onSuccess, onError) => {
  return (dispatch, getState) => {
    fetch(getMPPEndpoint('updateMPPLeague', challengeId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
        } else {
          if (onSuccess) onSuccess(data, payload);
        }
      })
      .catch(error => {
        if (onError) onError(error);
      });
  };
};

export const REQUEST_FETCH_CALENDAR_BY_LEAGUE =
  'REQUEST_FETCH_CALENDAR_BY_LEAGUE';
export const SUCCESS_FETCH_CALENDAR_BY_LEAGUE =
  'SUCCESS_FETCH_CALENDAR_BY_LEAGUE';
export const FAIL_FETCH_CALENDAR_BY_LEAGUE = 'FAIL_FETCH_CALENDAR_BY_LEAGUE';

export const fetchCalendarByDivision = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('fetchCalendarByDivision', payload.divisionId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess && payload.onSuccess(data);
        }
      });
  };
};

export const fetchCalendarByDivisionByGameWeekNumber = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_CALENDAR_BY_LEAGUE, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchCalendarByDivisionByGameWeekNumber', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_CALENDAR_BY_LEAGUE});
        else
          dispatch({
            type: SUCCESS_FETCH_CALENDAR_BY_LEAGUE,
            data,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_CALENDAR_BY_LEAGUE) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_RANKING_BY_LEAGUE =
  'REQUEST_FETCH_RANKING_BY_LEAGUE';
export const SUCCESS_FETCH_RANKING_BY_LEAGUE =
  'SUCCESS_FETCH_RANKING_BY_LEAGUE';
export const FAIL_FETCH_RANKING_BY_LEAGUE = 'FAIL_FETCH_RANKING_BY_LEAGUE';

export const fetchRankingByDivision = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_RANKING_BY_LEAGUE, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchRankingByLeague', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        data.leagueId = payload.divisionId;
        if (data.error) dispatch({type: FAIL_FETCH_RANKING_BY_LEAGUE});
        else dispatch({type: SUCCESS_FETCH_RANKING_BY_LEAGUE, data});

        if (onSuccess) onSuccess(data.data, payload);
      })
      .catch((error, type = FAIL_FETCH_RANKING_BY_LEAGUE) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_EDIT_MASTER_LEAGUE = 'REQUEST_EDIT_MASTER_LEAGUE';
export const SUCCESS_EDIT_MASTER_LEAGUE = 'SUCCESS_EDIT_MASTER_LEAGUE';
export const FAIL_EDIT_MASTER_LEAGUE = 'FAIL_EDIT_MASTER_LEAGUE';

export const editMasterLeague = (payload, masterLeagueId, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_EDIT_MASTER_LEAGUE, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('editMasterLeague', masterLeagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_EDIT_MASTER_LEAGUE});
        else dispatch({type: SUCCESS_EDIT_MASTER_LEAGUE, data});
        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_EDIT_MASTER_LEAGUE) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/league.js